module.exports = __webpack_public_path__ + "img/img_detail3.6b395cef.png";